module.exports = __webpack_public_path__ + "media/images/logos/Universiti-Tenaga-Nasional-ba19ab96fe59c374c973c3f93af636a7.svg";